import React from 'react';

import { connect } from 'react-redux';
import { fromReservation } from 'store/selectors';

import { ReservationWrapper } from 'components';

const ReservationWrapperContainer = props => <ReservationWrapper {...props} />;

const mapStateToProps = state => ({
  departures: fromReservation.getDepartures(state),
});

export default connect(mapStateToProps)(ReservationWrapperContainer);



// WEBPACK FOOTER //
// ./src/containers/ReservationWrapper.js